import { createSlice } from "@reduxjs/toolkit";
import { getAllDriverUserAction, getDriverUserAction, insertUpdateDriverUserAction, DriverUserChangeStatusACTION } from "../../actions/settingActions/driverUserActions";
import { toast } from 'react-toastify';
import { Enums } from "../../../helper/constants/enums";

const INITIAL_STATE = {
    DriverUser: {
        data: {
            records: [],
            totalRecords: 0,
        },
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    selectedDriverUser: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    insertUpdateDriverUser: {
        data: {},

        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },
    deleteDriverUser: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    }
};

const DriverUserReducer = createSlice({
    name: "DriverUser",
    initialState: INITIAL_STATE,
    reducers: {

        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetDriverUserDetailsState(state, action) {
            state.selectedDriverUser = INITIAL_STATE.selectedDriverUser;
            state.insertUpdateDriverUser = INITIAL_STATE.insertUpdateDriverUser;
        },
    },
    extraReducers: (builder) => {

        builder.addCase(getAllDriverUserAction.fulfilled, (state, action) => {
            // console.log("action.payload.data", action.payload);
            state.DriverUser.data = action.payload.data;
            state.DriverUser.apiMsg.status = action.meta.requestStatus;
            state.DriverUser.apiMsg.message = "success";
            // console.log( "state.DriverUser.data",  state.DriverUser.data.records);
        });
        builder.addCase(getAllDriverUserAction.pending, (state, action) => {
            state.DriverUser.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getAllDriverUserAction.rejected, (state, action) => {
            state.DriverUser.apiMsg.message = action.error.message;
            state.DriverUser.apiMsg.status = action.meta.requestStatus;
        });


        builder.addCase(getDriverUserAction.fulfilled, (state, action) => {
            state.selectedDriverUser.data = action.payload.data;
            state.selectedDriverUser.apiMsg.status = action.meta.requestStatus;
            state.selectedDriverUser.apiMsg.message = action.payload.message.message;
        });

        builder.addCase(getDriverUserAction.pending, (state, action) => {
            state.selectedDriverUser.data = null;
            state.selectedDriverUser.apiMsg.message = action.meta.requestStatus;;
            state.selectedDriverUser.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(getDriverUserAction.rejected, (state, action) => {
            state.selectedDriverUser.apiMsg.message = action.error.message;
            state.selectedDriverUser.apiMsg.status = action.meta.requestStatus;
        });


        builder.addCase(
            insertUpdateDriverUserAction.fulfilled,
            (state, action) => {
                // state.insertUpdateDriverUser.data = action.payload.data.data;
                if (action.meta.arg) {
                    const newData = action.meta.arg;
                    const existingRecords = state.DriverUser.data.records;
                    const index = existingRecords ? existingRecords.findIndex(record => record.userID === newData.userID) : -1;

                    if (!newData.userID) {
                        newData.userID = action.payload.data.data;
                    }
                    if (index !== -1) {
                        existingRecords[index] = {
                            ...existingRecords[index],
                             ...newData,
                        };
                    }
                    else {
                        if(newData.CheckuserType == Enums.UserType.MasterAdmin || newData.CheckuserType == Enums.UserType.MasterAdminUser){
                            if(newData.businessID == newData.filterBusinessID){
                                existingRecords.push(newData);
                                state.DriverUser.data.totalRecords = state.DriverUser.data.totalRecords + 1;
                            }
                        }else{
                            existingRecords.push(newData);
                            state.DriverUser.data.totalRecords = state.DriverUser.data.totalRecords + 1;
                        }
                    }
                    state.DriverUser.data.records = existingRecords;

                    state.insertUpdateDriverUser.data = {
                        userID: newData.userID,
                        firstName: newData.firstName,
                        lastName: newData.lastName,
                        userName: newData.userName,
                        roleID: newData.roleID,
                        roleName: newData.roleName,
                        active: newData.active,
                    };
                }

                state.insertUpdateDriverUser.apiMsg.status = action.meta.requestStatus;
                state.insertUpdateDriverUser.apiMsg.message = action.payload.message.message;
                toast.success(action.payload.message.message, {
                    position: "bottom-center",
                    toastId: "success"
                });
            }
        );
        builder.addCase(
            insertUpdateDriverUserAction.pending,
            (state, action) => {
                state.insertUpdateDriverUser.apiMsg.status = action.meta.requestStatus;
            }
        );
        builder.addCase(
            insertUpdateDriverUserAction.rejected,
            (state, action) => {

                state.insertUpdateDriverUser.apiMsg.message = action.error.message;
                state.insertUpdateDriverUser.apiMsg.status = action.meta.requestStatus;

                toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                    position: "bottom-center",
                    toastId: "error"
                });
            }
        );


        builder.addCase(DriverUserChangeStatusACTION.fulfilled, (state, action) => {
            if (action.meta.arg.StatusType === Enums.ChangeStatus.Delete) {
                const existingRecords = state.DriverUser.data.records;
                const roleIdToDelete = action.payload.data.Id;
                const updatedRecords = existingRecords.filter(record => record.userID !== roleIdToDelete);
                state.DriverUser.data.records = updatedRecords;
                state.DriverUser.data.totalRecords = state.DriverUser.data.totalRecords - 1;
            }
            else if (action.meta.arg.StatusType === Enums.ChangeStatus.Active) {
                const newData = action.meta.arg;
                const existingRecords = state.DriverUser.data.records;

                const index = existingRecords.findIndex(record => record.userID === newData.Id);
                if (index !== -1) {
                    existingRecords[index] = {
                        ...existingRecords[index],
                        active: true,
                    };
                }
            }
            else if (action.meta.arg.StatusType === Enums.ChangeStatus.Inactive) {
                const newData = action.meta.arg;
                const existingRecords = state.DriverUser.data.records;

                const index = existingRecords.findIndex(record => record.userID === newData.Id);
                if (index !== -1) {
                    existingRecords[index] = {
                        ...existingRecords[index],
                        active: false,
                    };
                }

            }
            state.deleteDriverUser.apiMsg.status = action.meta.requestStatus;
            state.deleteDriverUser.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(DriverUserChangeStatusACTION.pending, (state, action) => {
            state.deleteDriverUser.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(DriverUserChangeStatusACTION.rejected, (state, action) => {
            state.deleteDriverUser.apiMsg.message = action.error.message;
            state.deleteDriverUser.apiMsg.status = action.meta.requestStatus;
        });
    }
});

export const { RESET, ResetDriverUserDetailsState } = DriverUserReducer.actions;
export default DriverUserReducer.reducer;